import React from 'react'
import './loader.css'

const loader = () => {
  return (
    <div className="respond">
      <div className="lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  )
}

export default loader



// WEBPACK FOOTER //
// ./src/components/Loader/index.js